export const roles = {
  ANONYMOUS: "anonymous",
  SITE_MEMBER: "site-member",
  BUSINESS_ADMIN: "business-admin",
  TASK_ADMIN: "task-admin",
  SECURITY_OFFICER: "security-officer",
  DEVELOPER: "developer"
};